<template>
  <div class="tag-user-rank-discount rounded-circle d-flex flex-column align-items-center justify-content-center">
    <div>會員<br>特價</div>
  </div>
</template>

<script>
export default {
  name: 'TagUserRank'
}
</script>

<style scoped>
.tag-user-rank-discount {
  width: 48px;
  height: 48px;
  background-color: var(--loft-color);
  color: white;
  font-size: 14px;
  font-family: 'Noto Serif TC', serif;
  font-weight: 700;
  line-height: 1;
}
</style>
